// extracted by mini-css-extract-plugin
module.exports = {"bg":"Carousel_bg__33puO","carousel":"Carousel_carousel__3URdL"};